
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/en'
import 'dayjs/locale/nl'
import 'dayjs/locale/fr'
import duration from 'dayjs/plugin/duration'
import localeData from 'dayjs/plugin/localeData'
import isBetween from 'dayjs/plugin/isBetween'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'


dayjs.extend(updateLocale)

dayjs.extend(duration)
dayjs.extend(localeData)
dayjs.extend(isBetween)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(quarterOfYear)
dayjs.extend(localizedFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(timezone)
dayjs.extend(utc)



// defaultLocale: "nl"


dayjs.updateLocale("nl")
dayjs.locale('nl')


export default dayjs
